import { type SxProps, type Theme } from "@mui/material";
import { theme as appTheme } from "@/types/theme";

const categoryBaseSx: SxProps<Theme> = {
  borderRadius: "4px",
  borderStyle: "solid",
  borderWidth: 1,
  fontSize: "14px",
  fontWeight: 500,
  padding: { xs: "4px 8px", md: "6px 8px" },
  textAlign: "center",
  flexShrink: 0,
  minWidth: "110px",
};

/**
 * カテゴリ名に応じたスタイル（SxProps）を取得します。
 * @param category カテゴリ名
 * @returns スタイルオブジェクト
 */
export const getCategorySx = (category: string): SxProps<Theme> => {
  if (category === "メンテナンス") {
    return {
      ...categoryBaseSx,
      color: appTheme.palette.white.main,
      backgroundColor: appTheme.palette.accent.main,
      borderColor: appTheme.palette.accent.main,
    };
  }
  return {
    ...categoryBaseSx,
    color: appTheme.palette.primary.main,
    borderColor: appTheme.palette.primary.main,
  };
};
